import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from '@apollo/client'
import { Region } from '@babylon/consumer-api/types'

import regionQuery from '@/queries/Region'
import { useLocalisation } from '@/redux/productConfig/selectors'
import { setRegionInfo } from '@/redux/regionInfo/actions'
import { useRegionInfo } from '@/redux/regionInfo/selectors'

type RegionByISOResponse = {
  regionByIso: Region
}

const useFetchRegionInfo = () => {
  const { region } = useLocalisation()
  const { iso_code: isoCode } = useRegionInfo()
  const dispatch = useDispatch()

  const {
    data: { regionByIso: regionData = null } = {},
    loading: regionLoading,
  } = useQuery<RegionByISOResponse>(regionQuery, {
    variables: { isoCode: region },
    skip: Boolean(isoCode) && region === isoCode,
  })

  useEffect(() => {
    if (regionData) {
      dispatch(setRegionInfo(regionData))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionData])

  return {
    data: regionData,
    loading: regionLoading,
  }
}

export default useFetchRegionInfo
